import React, { Fragment ,useContext} from 'react'
import {Button,Icon} from 'antd'
import {AppTableSearchContext} from 'qcc'

interface AppTableSearchAdvancedProps{
    lableWidth?:number
}

export class AppTableSearchAdvanced extends React.Component<AppTableSearchAdvancedProps> {

    renderGroup = () =>{
        return (<colgroup>
            <col width={`${this.props.lableWidth || 100}px`} />
            <col/>
        </colgroup>)
    } 

    renderAdvanced = () =>{
        return (
            <div className='app-search-advanced'>
                <table cellPadding='0' cellSpacing='0' className='app-search-advanced-table'>
                    {this.renderGroup()}
                    <tbody>
                    {React.Children.toArray(this.props.children).map((child:any,index:number)=>{
                        let childProps = child.props
                        return (<tr key={index}>
                                <td className='app-search-advanced-table-item-td'>
                                    <label className='app-search-advanced-lable'>
                                    {childProps.lable||''}</label>
                                </td>
                                <td className='app-search-advanced-table-item-td'>
                                    {child}
                                </td>
                            </tr>)
                    })}
                    <ButtomArea />
                    </tbody>
                </table>
            </div>)
    }

    render(){
        return (<AppTableSearchContext.Consumer>
            {appTableSearchContext =>{
                if(appTableSearchContext.showMore)
                    return this.renderAdvanced();
                else 
                    return <Fragment />;
            }}
        </AppTableSearchContext.Consumer>)
    } 
}


const ButtomArea = () =>{
    const {onSearch,clearSearch}  = useContext(AppTableSearchContext)
    return (<tr>
        <td className='app-search-advanced-button-content-td' colSpan={2}>
            <Button 
                size='small' 
                style={{marginRight:10,fontSize:'12px'}} 
                type='primary' 
                onClick = {onSearch}
            >搜索</Button>
            <Button 
                size='small' 
                style={{marginRight:10,fontSize:'12px'}}
                onClick = {clearSearch}
            >清空</Button>
        </td>
    </tr>)
}



// WEBPACK FOOTER //
// ./src/qcc/AppTableSearch/AppTableSearchAdvanced.tsx